/**
 * @enum enumUserFeedbackType provides an enumeration of userFeedback types.
 * (Note: Try to keep the enumerations in alphabetical order to simplify viewing.)
 */
export enum enumUserFeedbackType {
  Compliment = 'Compliment',
  Problem = 'Problem',
  Suggestion = 'Suggestion',
}
